// extracted by mini-css-extract-plugin
export default {"icon":"RotuloSeplag_icon__AmV8X","label":"RotuloSeplag_label__lSwN7"};